/**
 * start.gg 連携の設定値。機密でない値だけを置く。
 * client_id / client_secret / scope は backend にのみ置き、認可 URL も backend が組み立てる。
 */
export const startggConfig = {
  /** authorize と token 交換で完全一致させる callback URL */
  redirectUri: process.env.REACT_APP_STARTGG_REDIRECT_URI ?? "",
  /** エントリーページを開くための大会 slug */
  tournamentSlug: process.env.REACT_APP_STARTGG_TOURNAMENT_SLUG ?? "",
  /** エントリー突合に使う Tournament.id */
  tournamentId: process.env.REACT_APP_STARTGG_TOURNAMENT_ID ?? "",
  /** この Event にエントリーしているかを判定する */
  eventId: process.env.REACT_APP_STARTGG_EVENT_ID ?? "",
  /** 連携を要求する SPWN イベント。他のイベントのチケットページには影響しない */
  spwnEventId: "evt_95b8YfhbJ8UPydQatkvI",
} as const;

/** start.gg の大会エントリーページ。iframe だとログインが維持されないため別タブで開く */
export const startggRegisterUrl = (): string =>
  `https://start.gg/tournament/${startggConfig.tournamentSlug}/register`;

/** 連携設定が揃っていて、かつ対象イベントのチケットページか */
export const isStartggEntryRequiredEvent = (
  eventId: string | undefined
): boolean => {
  if (!startggConfig.tournamentId) {
    return false;
  }
  return eventId === startggConfig.spwnEventId;
};

/** 連携を開始したページを覚えておくキー。同一タブ内の往復なので sessionStorage で足りる */
export const RETURN_PATH_STORAGE_KEY = "startggEntry:returnPath";

/** 連携後に戻るチケットページ */
export const startggTicketPagePath = (): string =>
  `/events/${startggConfig.spwnEventId}/ticket`;
